import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Users, Plus, Check, Flag } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Home-feed strip with pages/groups the user doesn't follow yet (one-tap follow). */
export default function PageSuggestions() {
  const [pages, setPages] = useState([]);
  const [joined, setJoined] = useState({});

  useEffect(() => {
    axios.get(`${API}/pages/suggestions?limit=8`).then((r) => setPages(r.data || [])).catch(() => {});
  }, []);

  const follow = async (p) => {
    try {
      await axios.post(`${API}/pages/${p.page_id}/follow`);
      setJoined((j) => ({ ...j, [p.page_id]: true }));
      toast.success(`Agora você segue ${p.name}`);
    } catch (e) { toast.error(e.response?.data?.detail || "Erro ao seguir"); }
  };

  if (pages.length === 0) return null;
  return (
    <Card className="p-4 bg-gradient-to-br from-cyan-500/5 to-primary/5" data-testid="page-suggestions-section">
      <div className="flex items-center gap-2 mb-3">
        <Flag className="w-4 h-4 text-primary" />
        <div className="font-bold text-sm">Grupos e páginas para você</div>
        <Link to="/pages" className="ml-auto text-[11px] text-primary hover:underline" data-testid="page-suggestions-see-all">Ver todos</Link>
      </div>
      <div className="flex gap-3 overflow-x-auto pb-2 -mx-1 px-1 snap-x scrollbar-hide">
        {pages.map((p) => (
          <div key={p.page_id} data-testid={`page-suggestion-${p.page_id}`} className="min-w-[200px] max-w-[200px] snap-start rounded-xl border bg-background p-3 flex flex-col gap-2">
            <Link to={`/pages/${p.page_id}`} className="flex items-center gap-2 min-w-0">
              <Avatar className="w-9 h-9"><AvatarImage src={p.avatar_url || p.picture} /><AvatarFallback className="text-xs">{p.name?.[0]}</AvatarFallback></Avatar>
              <div className="min-w-0">
                <div className="text-xs font-semibold truncate">{p.name}</div>
                <div className="text-[10px] text-muted-foreground truncate capitalize">{p.kind || p.category || "Página"}</div>
              </div>
            </Link>
            <div className="text-[10px] text-muted-foreground inline-flex items-center gap-1"><Users className="w-3 h-3" /> {p.followers_count} seguidores · {p.posts_count} posts</div>
            <Button size="sm" variant={joined[p.page_id] ? "outline" : "default"} className="rounded-full h-7 text-xs gap-1" disabled={!!joined[p.page_id]} onClick={() => follow(p)} data-testid={`page-suggestion-follow-${p.page_id}`}>
              {joined[p.page_id] ? <><Check className="w-3 h-3" /> Seguindo</> : <><Plus className="w-3 h-3" /> Seguir / Participar</>}
            </Button>
          </div>
        ))}
      </div>
    </Card>
  );
}
